
import { useAppSelector } from 'store/store';

type UseApplicationContextResponse = {
    connectedIcId: Nullable<string>;
    preferredLanguage: Nullable<string>;
    hasOnlyB2b2cAccess: Nullable<boolean>;
    canSearchPersonsAndCompanies: Nullable<boolean>;
    isSgGroupCurrentUser: Nullable<boolean>;
    isInsightSubscriptionsVisible: Nullable<boolean>;
    isSharinboxVisible: Nullable<boolean>;
    is3SKeyVisible: Nullable<boolean>;
    isSignatureVisible: Nullable<boolean>;
};

export const useApplicationContext = (): UseApplicationContextResponse => {
    const applicationContext = useAppSelector(state => state.applicationContext.context);

    return {
        connectedIcId: applicationContext?.user?.id,
        preferredLanguage: applicationContext?.preferredLanguage,
        hasOnlyB2b2cAccess: applicationContext?.hasOnlyB2b2cAccess,
        canSearchPersonsAndCompanies: applicationContext?.canSearchPersonsAndCompanies,
        isSgGroupCurrentUser: applicationContext?.isSgGroupCurrentUser,
        isInsightSubscriptionsVisible: applicationContext?.isSubscriptionsVisible,
        isSharinboxVisible: applicationContext?.isSharinboxVisible,
        is3SKeyVisible: applicationContext?.is3SKeyVisible,
        isSignatureVisible: applicationContext?.isSignatureVisible,
    };
};
